import React from "react";
import Weather from "./Weather";
import "./Weather.css";
import "./App.css";


export default function App () {
  return (
    <div className="App">
      <div className="container">

      
      <Weather defaultCity="Berlin"/> 
    </div>
</div>
  );
 
}

